import { useI18n } from 'domains/i18n/hooks'
import { useEffect } from 'preact/hooks'
import { useLiveRegion, useSeamlyIsHistoryLoaded } from 'ui/hooks/seamly-hooks'

const SeamlyNewNotifications = () => {
  const { t } = useI18n()
  const isHistoryLoaded = useSeamlyIsHistoryLoaded()
  const { sendPolite } = useLiveRegion()

  useEffect(() => {
    if (isHistoryLoaded) {
      // Ensure that the live region has stabilised if this is
      // an effect of setting this on page load.
      setTimeout(() => {
        sendPolite(t('window.srTexts.onHistoryLoad'))
      }, 500)
    }
  }, [isHistoryLoaded, t, sendPolite])

  return null
}

export default SeamlyNewNotifications
